import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Card, Typography, Row, Col } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { handleLogin } from '../data/AuthenticationApi';

const { Text } = Typography;

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        if (token && location.pathname === '/login') {
            navigate('/', { replace: true });
        }
    }, [token, navigate, location]);


    const handleSubmit = async () => {
        const response = await handleLogin(email, password);

        if (response.success) {
            setTimeout(() => {
                setToken(response.token);
                setError(null);
                localStorage.setItem('token', response.token);
                localStorage.setItem('token_expires_in', response.expires_in);
                localStorage.setItem('token_saved_at', Date.now());
                navigate('/');
            }, 1000);
        } else {
            setError(response.error);
        }
    };
  

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#1A481B', backgroundImage: `url(${process.env.PUBLIC_URL}/images/login_image.png)`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom' }}>    
            <Row>
                <Col xs={24} md={24} style={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
                    <Card style={{ width: 600, margin: '20px auto', padding: 20, backgroundColor: 'rgba(255, 255, 255, 0.7)', border: 'none' }}>
                        <div className="logoo">
                            <img src={`${process.env.PUBLIC_URL}/images/theros_logo.png`} alt="Theros" style={{ maxWidth: '50%', margin: '10px auto', display: 'block' }}></img>
                        </div>
                        {error && <Text type="danger">{error}</Text>}

                        <Form layout="vertical" onFinish={handleSubmit}>
                            <Form.Item>
                                <Input 
                                    prefix={<UserOutlined style={{ fontSize: '20px', color: '#335001' }} />} 
                                    value={email} 
                                    onChange={(e) => setEmail(e.target.value)} 
                                    placeholder="Email Address" 
                                    style={{ height: '45px', marginTop: 20 }}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Input.Password 
                                    prefix={<LockOutlined style={{ fontSize: '20px', color: '#335001' }} />} 
                                    value={password} 
                                    onChange={(e) => setPassword(e.target.value)} 
                                    placeholder="Password" 
                                    style={{ height: '45px', marginTop: 20 }}
                                />
                            </Form.Item>
                            <Form.Item style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button 
                                    type="primary" 
                                    htmlType="submit" 
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#2A3D00'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#1A481B'}
                                    style={{ backgroundColor: '#1A481B', padding: '24px 30px', fontSize: '20px' }}>                                
                                        Sign In
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Login;
